/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Services_Svc_Save_Point_1Inputs */

const en_services_svc_save_point_1 = /** @type {(inputs: Services_Svc_Save_Point_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI assistants and RAG knowledge bases over your documents`)
};

const lv_services_svc_save_point_1 = /** @type {(inputs: Services_Svc_Save_Point_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI asistenti un RAG zināšanu bāzes no Jūsu dokumentiem`)
};

/**
* | output |
* | --- |
* | "AI assistants and RAG knowledge bases over your documents" |
*
* @param {Services_Svc_Save_Point_1Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const services_svc_save_point_1 = /** @type {((inputs?: Services_Svc_Save_Point_1Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Services_Svc_Save_Point_1Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_services_svc_save_point_1(inputs)
	return en_services_svc_save_point_1(inputs)
});